const state = {
  error: "",
  success: "",
  warning: "",
  info: ""
};

const mutations = {
  SET_ERROR(state, message) {
    state.error = message || "";
    // Clear other notifications when setting error
    if (message) {
      state.success = "";
      state.warning = "";
      state.info = "";
    }
  },
  
  SET_SUCCESS(state, message) {
    state.success = message || "";
    // Clear other notifications when setting success
    if (message) {
      state.error = "";
      state.warning = "";
      state.info = "";
    }
  },
  
  SET_WARNING(state, message) {
    state.warning = message || "";
    // Clear other notifications when setting warning
    if (message) {
      state.error = "";
      state.success = "";
      state.info = "";
    }
  },
  
  SET_INFO(state, message) {
    state.info = message || "";
    // Clear other notifications when setting info
    if (message) {
      state.error = "";
      state.success = "";
      state.warning = "";
    }
  },
  
  CLEAR_ALL(state) {
    state.error = "";
    state.success = "";
    state.warning = "";
    state.info = "";
  }
};

const actions = {
  showError({ commit }, message) {
    commit("SET_ERROR", message);
    setTimeout(() => commit("SET_ERROR", ""), 5000);
  },
  
  showSuccess({ commit }, message) {
    commit("SET_SUCCESS", message);
    setTimeout(() => commit("SET_SUCCESS", ""), 5000);
  },
  
  showWarning({ commit }, message) {
    commit("SET_WARNING", message);
    setTimeout(() => commit("SET_WARNING", ""), 5000);
  },
  
  showInfo({ commit }, message) {
    commit("SET_INFO", message);
    setTimeout(() => commit("SET_INFO", ""), 5000);
  },
  
  clearAll({ commit }) {
    commit("CLEAR_ALL");
  }
};

const getters = {
  error: state => state.error,
  success: state => state.success,
  warning: state => state.warning,
  info: state => state.info,
  hasError: state => !!state.error,
  hasSuccess: state => !!state.success,
  hasWarning: state => !!state.warning,
  hasInfo: state => !!state.info,
  hasAnyNotification: state => !!(state.error || state.success || state.warning || state.info)
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};